import {signal} from '@angular/core';
import {CdkStep, CdkStepper, StepperSelectionEvent} from '@angular/cdk/stepper';

/**
 * Merkt sich, welche Schritte einer Bestellstrecke der Kunde schon geöffnet hat.
 *
 * Ein Schritt darf erst als erledigt gelten, wenn der Kunde ihn gesehen hat. Sonst markierte ein von
 * Anfang an gültiges Formular (vorgewählte Prämie, vorbefüllte Adresse) den Header schon als erledigt,
 * bevor der Schritt überhaupt erreichbar war - und der lineare Stepper ließe ihn beim Weiterschalten
 * über einen Header aus.
 */
export class VisitedSteps {
  private readonly visited = signal<ReadonlySet<CdkStep>>(new Set());

  /** Aus (selectionChange) des Steppers aufrufen. */
  track(event: StepperSelectionEvent): void {
    this.visited.update(steps => new Set(steps)
      .add(event.previouslySelectedStep)
      .add(event.selectedStep));
  }

  /**
   * Der gerade geöffnete Schritt zählt mit - auch der Startschritt, für den es kein selectionChange
   * gibt. Er muss schon beim Klick auf "Weiter" als erledigt gelten, sonst sperrt der lineare Stepper.
   */
  isVisited(step: CdkStep, stepper: CdkStepper): boolean {
    return stepper?.selected === step || this.visited().has(step);
  }
}
